<template>
  <VaSidebar v-model="writableVisible" :width="sidebarWidth" :color="color" minimized-width="0">
    <RecursiveSidebarItem
      v-for="(route, index) in navigationRoutes.routes"
      :key="index"
      :route="route"
      :depth="1"
      :active-route="route"
    />
  </VaSidebar>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'
import RecursiveSidebarItem from './RecursiveSidebarItem.vue'
import navigationRoutes from './NavigationRoutes'
import { useUserStore } from '@/stores/user-store'

const props = defineProps({
  visible: { type: Boolean, default: true },
  mobile: { type: Boolean, default: false },
})
const emit = defineEmits(['update:visible'])

const route = useRoute()
const { getColor, colorToRgba } = useColors()
const { t } = useI18n()
const store = useUserStore()

const sidebarWidth = computed(() => (props.mobile ? '100vw' : '280px'))
const color = computed(() => getColor('background-secondary'))
const activeColor = computed(() => colorToRgba(getColor('focus'), 0.1))
const writableVisible = computed({
  get: () => props.visible,
  set: (v) => emit('update:visible', v),
})
</script>
